

import { z } from "zod";
import * as themeScheme from "@ecp-redux/dto/themeSettings/themeSettings.schemes";

export const ICompanyInfoFormMessagesScheme = z.object({
  next_button: themeScheme
    .MessageScheme
    .default("Dalej"),
  main_title_text: themeScheme
    .MessageScheme
    .default("Powiedz nam więcej o "),
  question_1_title: themeScheme
    .MessageScheme
    .default("Czym zajmuje się Twoja firma?"),
  question_1_description: themeScheme
    .MessageScheme
    .default("Możesz wybrać kilka obszarów"),
  question_1_answer_1: themeScheme
    .MessageScheme
    .default("Wykonawstwo instalacji "),
  question_1_answer_2: themeScheme
    .MessageScheme
    .default("Handel materiałami instalacyjnymi"),
  question_1_answer_3: themeScheme
    .MessageScheme
    .default("Działalność budowlana lub deweloperska"),
  question_1_answer_4: themeScheme
    .MessageScheme
    .default("Działalność niezwiązana z instalacjami"),
  question_1_answer_5: themeScheme
    .MessageScheme
    .default("Inne"),
  question_2_title: themeScheme
    .MessageScheme
    .default("Jaki jest Twój przeciętny roczny budżet na zakupy w branży instalacyjno-grzewczej?"),
  question_2_answer_1: themeScheme
    .MessageScheme
    .default("do 50 tys. zł"),
  question_2_answer_2: themeScheme
    .MessageScheme
    .default("51 - 250 tys. zł"),
  question_2_answer_3: themeScheme
    .MessageScheme
    .default("251 - 500 tys. zł"),
  question_2_answer_4: themeScheme
    .MessageScheme
    .default("501 - 999 tys. zł"),
  question_2_answer_5: themeScheme
    .MessageScheme
    .default("1 - 3 mln zł"),
  question_2_answer_6: themeScheme
    .MessageScheme
    .default("powyżej 3 mln zł"),
  question_3_title: themeScheme
    .MessageScheme
    .default("Która z naszych hurtowni jest najbliżej Twoich inwestycji"),
  select_warehouse_text: themeScheme
    .MessageScheme
    .default("Wybierz hurtownie"),
});

export const ICompanyInfoFormSettingsScheme = z.object({
  main_color: themeScheme.ColorIdScheme.default("color$$1").catch("color$$1"),
  secondary_color: themeScheme.ColorIdScheme.default("color$$2").catch("color$$2"),
  main_title_typo: themeScheme.TypoIdScheme.default("typo$$1").catch("typo$$1"),
  question_typo: themeScheme.TypoIdScheme.default("typo$$1").catch("typo$$1"),
  description_typo: themeScheme.TypoIdScheme.default("typo$$1").catch("typo$$1"),
  answer_typo: themeScheme.TypoIdScheme.default("typo$$1").catch("typo$$1"),
  next_button_style: themeScheme.ButtonIdScheme.default("button$$1").catch("button$$1"),
  select_warehouse_style: themeScheme.ButtonIdScheme.default("button$$1").catch("button$$1"),
  error_background_color: themeScheme.ColorIdScheme.default("color$$1").catch("color$$1"),
  error_text_color: themeScheme.ColorIdScheme.default("color$$1").catch("color$$1"),
  border_color: themeScheme.ColorIdScheme.default("color$$1").catch("color$$1"),
  selected_answer_background_color: themeScheme.ColorIdScheme.default("color$$1").catch("color$$1"),
  no_data_redirect_url: themeScheme.UrlScheme.default("/join-the-customers").catch("/join-the-customers"),
  sucess_form_redirect_url: themeScheme.UrlScheme.default("/join-company-contact").catch("/join-company-contact"),

});

export const getValidationCompanyInfoSchema = z.object({
  businessArea: z
    .array(z.string())
    .min(1, { message: "Wybierz przynajmniej jedną z opcji" }),
  purchaseVolume: z
    .string({ required_error: "Wybierz przynajmniej jedną z opcji" }),
  companyBranch: z
    .string({ required_error: "Wybierz hurtownie" })
});
